import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BreadcrumbComponent } from './breadcrumb.component';
import { AnchorModule } from '@finder/shared/components/anchor/anchor.module';
import { SafeHtmlPipeModule } from '@finder/shared/utils/pipes/safe-html/safe.html.module';

@NgModule({
    imports: [
        CommonModule,
        AnchorModule,
        SafeHtmlPipeModule,
    ],
    declarations: [
        BreadcrumbComponent
    ],
    providers: [],
    exports: [
        BreadcrumbComponent
    ]
})
export class BreadcrumbModule {
    static entry = BreadcrumbComponent;
}
